export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT || 'http://localhost:3000';
export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY || '';
export const MSAL_CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID || '';
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'development';

// Log environment variables in development to help with debugging
if (import.meta.env.DEV) {
  console.log('Environment variables loaded:', {
    API_ENDPOINT,
    GOOGLE_API_KEY: GOOGLE_API_KEY ? '***' : 'MISSING',
    MSAL_CLIENT_ID: MSAL_CLIENT_ID ? '***' : 'MISSING',
    ENVIRONMENT,
  });
}
